import { useTranslation } from 'react-i18next';

export default function CrewSection({
    crew,
    notes,
    onCrewInteraction,
    onCrewComments,
    onNotesChange,
    lang
}) {

    const { t } = useTranslation();

    return (

        <>

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Información sobre la tripulación")}</h2>

            <div className="u-form-group u-form-name u-label-none fontmontserrat">
                <label htmlFor="crewinteraction" className="u-form-control-hidden u-label fontmontserrat">{t("Que la tripulación interactúe con nosotros")}</label>
                <input
                    type="radio"
                    checked={crew.interaction === "interact"}
                    onChange={() =>
                        onCrewInteraction("interact")
                    }
                    id="crewinteraction"
                    name="crewinteraction"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                    required
                />
                {t("Que la tripulación interactúe con nosotros")}
            </div>

            <div className="u-form-group u-form-name u-label-none fontmontserrat">
                <label htmlFor="crewinteraction" className="u-form-control-hidden u-label fontmontserrat">{t("Preferimos nuestra privacidad")}</label>
                <input
                    type="radio"
                    checked={crew.interaction === "privacy"}
                    onChange={() =>
                        onCrewInteraction("privacy")
                    }
                    id="crewinteraction"
                    name="crewinteraction"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                    required
                />
                {t("Preferimos nuestra privacidad")}
            </div>

            <div className="u-form-group u-form-name u-label-none fontmontserrat">
                <label htmlFor="crewinteraction" className="u-form-control-hidden u-label fontmontserrat">{t("Un equilibrio entre ambas opciones")}</label>
                <input
                    type="radio"
                    checked={crew.interaction === "balanced"}
                    onChange={() =>
                        onCrewInteraction("balanced")
                    }
                    id="crewinteraction"
                    name="crewinteraction"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                    required
                />
                {t("Un equilibrio entre ambas opciones")}
            </div>

            <div className="u-form-group u-form-name u-label-none fontmontserrat">
                <label htmlFor="crewcomments" className="u-form-control-hidden u-label fontmontserrat">{t("Otras observaciones")}</label>
                <textarea
                    placeholder={t("Otras observaciones")}
                    rows="4"
                    id="crewcomments"
                    id="crewcomments"
                    value={crew.comments}
                    onChange={(e) =>
                        onCrewComments(e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none fontmontserrat">
                <label htmlFor="notes" className="u-form-control-hidden u-label fontmontserrat">{t("Notas personales adicionaless")}</label>
                <textarea
                    placeholder={t("Notas personales adicionaless")}
                    rows="5"
                    id="notes"
                    name="notes"
                    value={notes}
                    onChange={(e) =>
                        onNotesChange(e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>
        </>

    );

}
